import { Component, Input } from '@angular/core';
import { PhotoInterface } from '@app/core/interfaces/photo.interface';
import { Observable } from 'rxjs';
import { IntersectionObserverService } from '@app/core/services/intersection-observer.service';

@Component({
    selector: 'ins-photo',
    templateUrl: './photo.component.html',
    styleUrls: ['./photo.component.scss']
})
export class PhotoComponent {
    @Input() photos: PhotoInterface[];
    @Input() loaded: boolean;

    public isScreenLarge$: Observable<boolean> = this.intersectionObserverService.isScreenLarge$;
    public isScreenMedium$: Observable<boolean> = this.intersectionObserverService.isScreenMedium$;

    constructor(private intersectionObserverService: IntersectionObserverService) {}
}
